import React, { useState } from "react";
import PropTypes from "prop-types";
import { useField } from "formik";
import classnames from "classnames";
import BlockActions from "components/FormerEditor/BlockActions";
import { useFormikContext } from "formik";
import EntityHeader from "../EntityHeader";
import { setEditorFocus } from "utils/builder";
import { usePageBuilderContext } from "utils/context";
import { BLOCK_REGISTRY } from "utils/constants/builder";
import { STATE_KEYS } from "utils/constants/state";
import Analytics, { SHOW_BLOCK_SETTINGS } from "utils/analytics";
import { useHoverProps } from "utils/hooks";
import { getItemDraggingProps } from "utils/drag";
import Grip from "components/Grip";
import { useEntityPinning } from "utils/entity";
import get from "lodash/get";

const BlockItem = (props) => {
  const pageContext = usePageBuilderContext();
  const tracking = pageContext ? pageContext.tracking : {};
  const blockRegistry = pageContext ? pageContext.blockRegistry : {};

  const { values, setValues } = useFormikContext();
  const blockSettingsVisible = get(values, STATE_KEYS.EDITOR.VISIBILITY_PANEL);
  const { name, uuid, schema, uid, draggable, provided, snapshot } = props;
  const hasPinning = useEntityPinning(uid);

  const [_, meta] = useField(name);
  const { value } = meta;
  const active = value === uuid;
  const [hover, setHover] = useState();
  const hoverProps = useHoverProps({ hover, setHover });
  const containerProps = getItemDraggingProps(
    {
      className: classnames(
        "flex flex-column relative overflow-y-hidden-ns overflow-x-hidden-ns relative pa3 bh--inset",
        {
          "bg-content--secondary": hover || active,
          "bg-white": !hover
        }
      ),
      ...hoverProps,
      style: { minHeight: 64, cursor: "default" }
    },
    provided,
    snapshot
  );

  const openBlockSettings = () => {
    const blockRef = blockRegistry[uuid];

    const scrollContainer = blockRegistry[BLOCK_REGISTRY.SCROLL_CONTAINER];
    if (blockRef && blockRef.current) {
      console.log("Handle scrolling in container");
    }
    Analytics.track(SHOW_BLOCK_SETTINGS, {
      ...tracking,
      uid
    });
    setEditorFocus({
      values,
      setValues,
      focus: [
        {
          key: name,
          value: uuid
        },
        {
          key: STATE_KEYS.EDITOR.PRICING_ACTIVE_PRICE,
          value: null
        },
        {
          key: STATE_KEYS.EDITOR.PRICING_ACTIVE_PRODUCT,
          value: null
        },
        {
          key: STATE_KEYS.EDITOR.PRICING_INTENT,
          value: null
        }
      ]
    })();
  };

  const headerProps = {
    onClick: openBlockSettings,
    uid,
    active,
    hover,
    title: schema && schema.title,
    draggable,
    compress: blockSettingsVisible
  };

  return (
    <div {...containerProps}>
      <Grip hide={hasPinning} hover={hover} snapshot={snapshot} />
      <EntityHeader {...headerProps} />
      {(active || hover) && !blockSettingsVisible && (
        <BlockActions
          openBlockSettings={openBlockSettings}
          uid={uid}
          uuid={uuid}
          name={name}
        />
      )}
    </div>
  );
};

BlockItem.propTypes = {
  name: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,
  schema: PropTypes.object.isRequired,
  uid: PropTypes.string.isRequired,
  component: PropTypes.string.isRequired,
  entities: PropTypes.array
};

export default BlockItem;
